module.exports = __webpack_public_path__ + "media/info.8ce415eb.wav";